<template lang="html">
  <img src="@/assets/logo.png" alt="SThree" width="250" />
  <h1 class="title">Vul jouw gegevens in</h1>
  <input
    v-model="firstName"
    class="form-control field no-focusborder"
    type="text"
    ref="inputfield"
    placeholder="Naam"
    required
  />
  <!-- <input
    v-model="lastName"
    class="form-control field no-focusborder"
    type="text"
    ref="inputfield"
    placeholder="Studiejaar"
    required
  /> -->
  <input
    v-model="email"
    class="form-control field no-focusborder"
    type="email"
    ref="inputfield"
    placeholder="E-mailadres"
    required
  />
  {{ validateEmail }}
  <input
    v-model="phone"
    class="form-control field no-focusborder"
    type="text"
    ref="inputfield"
    placeholder="Telefoon"
    required
  />
  <div class="d-grid gap-2">
    <button
      type="button"
      class="btn btn-primary text-light btn-lg"
      :disabled="isDisabled == true"
      @click="setPersonalData()"
    >
      Volgende
    </button>
  </div>
</template>

<script>
export default {
  name: "PersonalDataScreen",
  data: () => ({
    firstName: null,
    lastName: null,
    email: null,
    phone: null,
  }),
  computed: {
    isDisabled() {
      if (this.firstName && this.email && this.phone) {
        if (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(this.email)) {
          return false;
        }
      }
      return true;
    },
    validateEmail() {
      let msg;
      if (this.email !== null) {
        if (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(this.email)) {
          msg = "";
        } else {
          msg = "Please enter a valid email address";
        }
      }
      return msg;
    },
  },
  methods: {
    setPersonalData() {
      this.$store.commit("setFirstName", this.firstName);
      this.$store.commit("setLastName", this.lastName);
      this.$store.commit("setPhone", this.phone);
      this.$store.commit("setEmail", this.email);
    },
  },
};
</script>

<style lang="css" scoped>
h1 {
  font-size: 40px;
  color: #000;
}
.title {
  padding-bottom: 10px;
}
.field {
  /* text-transform: uppercase; */
  margin: auto;
  outline: none;
  border: none;
  width: 100%;
  padding: 10px;
  font-size: 1.25rem;
  border-radius: 0px;
  text-align: center;
  margin-bottom: 20px;
  color: #fdf7ea;
  background-color: #000;
}
.field::placeholder {
  color: #bbb;
}
</style>
